/**
 * Cafe To Go — Theme JavaScript
 */

// CSS entry — imported here so Vite's module graph tracks SCSS dependencies.
// In production, Rollup extracts this to dist/css/style.css.
import '../css/style.css';

// Import helpers and components
import { helpers } from './theme/helpers.js';
import { headerMenu } from './theme/components/header-menu.js';
import { scrollReveal } from './theme/components/scroll-reveal.js';
import { faq } from './theme/components/faq.js';

window.theme = {
    globals: {
        isTouch: typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0),
    },

    helpers: helpers,

    init: function () {
        headerMenu.init();
        scrollReveal.init();
        faq.init();
    },
};

document.addEventListener('DOMContentLoaded', () => {
    window.theme.init();
});
